import { Button } from '@neo/index'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@neo/primitives/dialog'
import { capitalize } from 'lodash'
import { useState } from 'react'
import { FlowTypes } from 'v2/types'
import { logger } from 'v2/utils/logger'
import { useTypedReactFlow } from '../hooks/use-react-flow'
import { useFlowStore } from '../store'
import { getChannelTypeFromFlowType, updateSimilarNodesWithTriggerChange } from '../utils'

export const TriggerChangeConfirmationModal = () => {
  const { getNodes, updateNodeData } = useTypedReactFlow()
  const showTriggerChangeConfirmationModal = useFlowStore(
    (state) => state.showTriggerChangeConfirmationModal,
  )
  const triggerChangeData = useFlowStore((state) => state.triggerChangeData)
  const setShowTriggerChangeConfirmationModal = useFlowStore(
    (state) => state.setShowTriggerChangeConfirmationModal,
  )

  const oldTriggerType = triggerChangeData?.oldTriggerType || FlowTypes.incoming_call
  const newTriggerType = triggerChangeData?.newTriggerType || FlowTypes.incoming_call
  const [isUpdating, setIsUpdating] = useState(false)

  const handleYes = () => {
    setIsUpdating(true)
    try {
      updateSimilarNodesWithTriggerChange(oldTriggerType, newTriggerType, getNodes, updateNodeData)
      setShowTriggerChangeConfirmationModal(false)
    } catch (error) {
      logger.error('Failed to update similar nodes:', error)
    } finally {
      setIsUpdating(false)
    }
  }

  const handleSkip = () => {
    setShowTriggerChangeConfirmationModal(false)
  }

  // Get channel names for display using the existing utility function
  const oldChannel = getChannelTypeFromFlowType(oldTriggerType)
  const newChannel = getChannelTypeFromFlowType(newTriggerType)

  return (
    <Dialog
      open={showTriggerChangeConfirmationModal}
      onOpenChange={() => setShowTriggerChangeConfirmationModal(false)}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-h4-500">
            Change Channel for AI Conversation Nodes?
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-p-400 text-secondary">
            Trigger has been updated from{' '}
            <span className="text-p-600">{capitalize(oldChannel)}</span> to
            <span className="text-p-600"> {capitalize(newChannel)}</span>.
          </p>

          <p className="text-p-400 text-secondary">
            Do you want to update all
            <span className="text-p-600"> {capitalize(oldChannel)} AI Conversation nodes</span> with
            the <span className="text-p-600"> {capitalize(newChannel)}</span> channel?
          </p>

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              onClick={handleSkip}
              className="flex-1"
              disabled={isUpdating}
              data-testid="button-skip-trigger-update"
            >
              Skip
            </Button>
            <Button
              onClick={handleYes}
              className="flex-1"
              disabled={isUpdating}
              data-testid="button-confirm-trigger-update"
            >
              {isUpdating ? 'Updating...' : 'Yes, Update All'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
